import { useState, useEffect } from 'react'
/*
    Permet d'éviter de lancer des recherches tant que la personne n'a pas fini d'écrire dans l'input
*/
export const useDebounce = (value, milliSeconds) => {
 const [debouncedValue, setDebouncedValue] = useState(value);

 useEffect(() => {
   const handler = setTimeout(() => {
     setDebouncedValue(value);
   }, milliSeconds);

   return () => {
     clearTimeout(handler);
   };
 }, [value, milliSeconds]);

 return debouncedValue;
};
